import clsx from 'clsx';
import { memo } from 'react';

import { useDrawResults } from '../../hooks';
import { useDrawOptions } from '../../store';
import DrawKnockOutTeam from '../KnockOutTeam';

import { hydrateWithTranslations } from '@services/TranslatorService';

import * as styles from './styles.module.scss';

const DrawKnockOutResults = () => {
  const { filteredResults: results } = useDrawResults();
  const {
    options: { noMargin, calendarContext },
  } = useDrawOptions();

  if (!results.some((r) => r.groups.some((group) => !!group.teamSlots?.length))) return null;

  return (
    <div className={clsx('pk-mt--l', noMargin && 'pk-m--0', results.length > 1 && styles.knockoutWrapMoreRounds)}>
      {results?.map((result) => (
        <div key={result.round.id}>
          {results.length > 1 && (
            <h2 className={styles.knockoutRoundTitle}>{hydrateWithTranslations(result.round)?.name}</h2>
          )}
          <div className={clsx(styles.knockoutTeams, calendarContext && styles.knockoutTeamsCalendar)}>
            {result.groups.map((group) => (
              <DrawKnockOutTeam
                key={group.groupId}
                teams={[
                  group.teamSlots?.find((ts) => +ts.positionInGroup === 1 && ts.teams?.length)?.teams?.at(0),
                  group.teamSlots?.find((ts) => +ts.positionInGroup === 2 && ts.teams?.length)?.teams?.at(0),
                ]}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(DrawKnockOutResults);
